// extracted by mini-css-extract-plugin
export default {"chartContainer":"UsersChartSection_chartContainer__LkpYC"};